import { render, staticRenderFns } from "./FacetHero.vue?vue&type=template&id=249bd9bd&"
import script from "./FacetHero.vue?vue&type=script&lang=js&"
export * from "./FacetHero.vue?vue&type=script&lang=js&"
import style0 from "./FacetHero.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports